<!--
 * @Author: your name
 * @Date: 2020-11-20 01:04:24
 * @LastEditTime: 2021-04-06 15:29:27
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /v-intersection/src/components/code/demo3.vue
-->
<template>
  <div class="demo">
    <div class="content">
      <div class="block blue" v-intersection.quiet="handler" :key="3"></div>
      <div class="block"></div>
    </div>
    <span class="tip button" :class="color"
      >isShow?:{{ isShow }}  times:{{times}}
    </span>
  </div>
</template>

<script>
export default {

  data() {
    return {
      isShow: "not handle yet , i don't know",
        times:0
    };
  },

  computed: {
     color(){
     if( this.isShow === true ){
       return 'green'
     }else if(this.isShow === false){
        return 'red'
     }else{
       return 'orange'
     }
    }
  },
  methods: {
    handler(entries) {
      entries[0].isIntersecting ? (this.isShow = true) : (this.isShow = false);
      this.times++
    },
    notify(){
      this.isShow?this.$toast.success("demo1 block is show"):this.$toast.error("demo1 block not show")
    }
  },
};
</script>


<style scoped>

</style>
